<template>
  <div id="repair-create-before">
    <file-upload-content @onFileChange="handleChangeImg" />
    <ul class="photo">
      <li
        class="photo-content"
        v-for="item in repairRecord.beforePhoto"
        :key="item.photoUid"
      >
        <img class="photo-content__img" :src="item.photoUrl" alt="" />
        <img
          class="photo-content__delete"
          src="../../assets/images/disabled_delete.svg"
          alt=""
          @click="handleDelete(item.photoUid)"
        />
      </li>
      <li class="photo-content"></li>
    </ul>
  </div>
</template>

<script>
import { getFileDataURL, getFileName } from '../../config/utils';
import fileUploadContent from '../layout/file-upload-content.vue';
export default {
  components: { fileUploadContent },
  props: {
    repairRecord: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    handleChangeImg({ files }) {
      Array.from(files).forEach(async (item, index) => {
        const test = await getFileDataURL(item, 'image');
        const imgItem = {
          photoName: getFileName(item),
          photoTypeEnum: 0,
          photoUrl: test,
          file: item,
          photoUid: index + Date.now()
        };
        this.repairRecord.beforePhoto.push(imgItem);
      });
    },
    handleDelete(id) {
      const deleteIndex = this.repairRecord.beforePhoto.findIndex(item => {
        return item.photoUid == id;
      });
      this.repairRecord.beforePhoto.splice(deleteIndex, 1);
    }
  }
};
</script>

<style lang="scss">
#repair-create-before {
  .photo {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    position: relative;
    margin-top: 20px;
    &-content {
      position: relative;
      width: 195px;
      &__img {
        width: 195px;
        height: 140px;
      }
      &__delete {
        position: absolute;
        right: 5px;
        bottom: 5px;
        width: 30px;
        cursor: pointer;
      }
    }
  }
}
</style>
